import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`featureCard${_vm.even ? ' even' : ''}`},[_c('div',{staticClass:"featureCardImg"},[_c('div',{staticClass:"fcImg"},[_c(VImg,{attrs:{"src":_vm.imgSrc}})],1)]),_c('div',{staticClass:"featureCardDesc"},[_c('div',{staticClass:"fcTitle"},[_vm._v(_vm._s(_vm.$t(`${_vm.resKey}.title`)))]),_c('div',{staticClass:"fcText"},[_vm._v(_vm._s(_vm.$t(`${_vm.resKey}.text`)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }